<div class="alert-badge color-alert-{{ displayAlert.type }}" *ngIf="displayAlert">
	<span class="material-icons icon">warning</span>
</div>
